import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

const LoadingOverlay = () => {
  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center font-body"
      style={{ backgroundColor: 'rgba(249,249,249,0.85)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)' }}
      dir="rtl"
    >
      {/* Card */}
      <div className="bg-surface-container-lowest rounded-xl p-8 text-center w-80 max-w-[88vw] shadow-[0px_24px_60px_rgba(0,106,98,0.12)] flex flex-col items-center">

        {/* Lottie animation */}
        <Player
          autoplay
          loop
          src="https://assets9.lottiefiles.com/packages/lf20_tll0j4bb.json"
          style={{ height: '160px', width: '160px' }}
        />

        {/* Pulse ring around icon (decorative) */}
        <div className="relative mb-5 -mt-2">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary to-primary-container flex items-center justify-center shadow-lg shadow-primary/25 mx-auto">
            <span
              className="material-symbols-outlined text-white text-2xl"
              style={{ fontVariationSettings: "'FILL' 1" }}
            >
              auto_awesome
            </span>
          </div>
          <span className="absolute inset-0 rounded-full bg-primary/20 animate-ping" />
        </div>

        <h2 className="text-xl font-headline font-bold text-on-surface mb-1">
          ה-AI בעבודה... ✨
        </h2>
        <p className="text-sm text-on-surface-variant leading-relaxed mb-6">
          הופכים את הסרטון למתכון מושלם עבורך
        </p>

        {/* Progress steps */}
        <div className="flex items-center gap-2 px-4 py-2.5 bg-surface-container-low rounded-full text-xs font-semibold">
          <span className="text-outline">🎬 וידאו</span>
          <span className="material-symbols-outlined text-sm text-outline-variant">arrow_back</span>
          <span className="text-primary font-bold">📝 מתכון</span>
          <span className="material-symbols-outlined text-sm text-outline-variant">arrow_back</span>
          <span className="text-outline">🍳 אוכל</span>
        </div>

      </div>
    </div>
  );
};

export default LoadingOverlay;